import styled from "styled-components";
import React from "react";
import { Link } from "gatsby";
import colors from "../../../../helpers/colors";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons/faAngleRight";

const Container = styled.div`
	padding: 24px 0px 21px 0;
`;

const BreadcrumbWrapper = styled.div`
	max-width: 1200px;
	margin: auto;
	display: flex;
	height: 100%;
`;

const TitleWrapper = styled.div`
	display: flex;
	align-items: start;

	@media (max-width: 769px) {
		width: 100%;
	}

    @media (max-width: 400px) {
        display: none;
    }
`;

const LibraryLink = styled(Link)`
	color: ${colors.mvBlack};
	font-size: 14px;
	font-weight: 400;
	text-decoration: none;
	margin-right: 10px;

	&:hover {
		text-decoration: underline;
	}
`;

const Separator = styled.span`
	color: ${colors.mvBlack};
	font-size: 15px;
	font-weight: 300;
    margin: 0 15px;

	@media (max-width: 500px) {
		font-size: 16px;
	}
`;

const BlogTitle = styled.span`
	color: ${colors.mvBlack};
	font-size: 14px;
	font-weight: 400;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;

	@media (max-width: 500px) {
		font-size: 16px;
	}
`;

const BreadcrumbSection = ({ title }) => {
	return (
		<Container>
			<BreadcrumbWrapper>
				<TitleWrapper>
					<LibraryLink to="/resources/">{"Content Library"}</LibraryLink>
					<Separator>
						<FontAwesomeIcon icon={faAngleRight} alt="Icon pointing right" />
					</Separator>
					<BlogTitle>{title}</BlogTitle>
				</TitleWrapper>
			</BreadcrumbWrapper>
		</Container>
	);
};

export default BreadcrumbSection;
